import { render, staticRenderFns } from "./TopProviderDiscount.vue?vue&type=template&id=fdf905b6&scoped=true"
import script from "./TopProviderDiscount.vue?vue&type=script&lang=js"
export * from "./TopProviderDiscount.vue?vue&type=script&lang=js"
import style0 from "./TopProviderDiscount.vue?vue&type=style&index=0&id=fdf905b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf905b6",
  null
  
)

export default component.exports